/**
 * Properties Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const propertiesAPI = {
  getAll: (params) => apiClient.get('/properties', { params }),
  getById: (id) => apiClient.get(`/properties/${id}`),
  getSummary: (params) => apiClient.get('/properties/stats/summary', { params }),
  create: (data) => apiClient.post('/properties', data),
  update: (id, data) => apiClient.put(`/properties/${id}`, data),
  updateRentalStatus: (id, data) => apiClient.patch(`/properties/${id}/rental-status`, data),
  delete: (id) => apiClient.delete(`/properties/${id}`),
  getProjections: (id, params) => apiClient.get(`/properties/${id}/projections`, { params }),
  createProjection: (id, data) => apiClient.post(`/properties/${id}/projections`, data),
  deleteProjection: (propertyId, projectionId) => apiClient.delete(`/properties/${propertyId}/projections/${projectionId}`),
};

export default propertiesAPI;

